import React from 'react';
import { useIntl } from 'react-intl';

import { useCurrentUser, useLocalStorage } from '@lib/hooks';

import messages from './messages';

export const SCHEDULE_VIEW_VERSION_STORAGE_KEY = (userId: string) => `lh:schedule-view-v2:${userId}:enabled`;

type TScheduleViewStorageVersionValues = {
  scheduleStorageV2: boolean;
  toggleScheduleViewV2: () => void;
  copyBanner: string;
};

function useScheduleViewStorageVersion(): TScheduleViewStorageVersionValues {
  const currentUser = useCurrentUser();
  const { formatMessage } = useIntl();

  const scheduleViewKey = SCHEDULE_VIEW_VERSION_STORAGE_KEY(currentUser?.id ?? '');

  const [isScheduleV2Storage, updatesSheduleStorageV2] = useLocalStorage(scheduleViewKey, 'true', true);
  const scheduleStorageV2 = JSON.parse(isScheduleV2Storage);

  const copyBanner = scheduleStorageV2 ? formatMessage(messages.newView) : formatMessage(messages.oldView);

  const toggleScheduleViewV2 = React.useCallback(() => updatesSheduleStorageV2(JSON.stringify(!scheduleStorageV2)), [
    scheduleStorageV2,
    updatesSheduleStorageV2,
  ]);

  const values = React.useMemo(() => ({ scheduleStorageV2, toggleScheduleViewV2, copyBanner }), [
    copyBanner,
    scheduleStorageV2,
    toggleScheduleViewV2,
  ]);

  return values;
}

export default useScheduleViewStorageVersion;
